import "./style.css";
import { AppContext } from "../../utils/ContextProvider";
import { useContext } from "react";

export default function ContextMenu(props) {
  
  const context = useContext(AppContext)
  const handleCollapsed = () => {
    props.node.data.collapsed = !props.node.data.collapsed;
    if (props.node.data.collapsed) props.collapseNode(props.node);
    else props.expandNode(props.node);
    props.setClickedNode(null);
    closeMenu()
  }

  const handleCircuit = (url) => {
    const newTab = window.open(url, '_blank');
    newTab.focus();
  }

  const closeMenu = () => {
    props.setShow(false);
    return;
  };

  return (
    <div className="fixed w-full h-full z-[999] overflow-hidden" onClick={closeMenu}>
      <div
        id="context-menu"
        className={`fixed z-[1000] w-[150px] bg-[#FFF] border rounded`}
        style={{ top: props.position.y, left: props.position.x }}
      >
        <div className="item" onClick={handleCollapsed}>
          {props.node && props.node.data && props.node.data.collapsed ? "Expand" : "Collapse"} Node
        </div>
        {props.node && props.node.data && ['circuit', 'gas', 'water'].includes(props.node.data.dataType) &&
          <div className="item" onClick={() => handleCircuit(`/circuit?channel_id=${props.node.data.channel_id}&tab=1`)}>
            View Circuit
          </div>}
        {props.node && props.node.data && context.getUserInfo && context.getUserInfo.access_buildings_and_operators_list && ['device'].includes(props.node.data.dataType) &&
          <div className="item" onClick={() => handleCircuit(`/circuit?device_id=${props.node.data.device_id}&tab=5`)}>
            View Device
          </div>}
      </div>
    </div>
  );
}
